import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import { getlanguagelist, getlanguage, changelanguage } from "../../helpers/changelanguage";
import { changeLanguage } from "../../actions/languagechangeAction";


class StaticHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      language   : getlanguage()
    }
    this.handleChange = this.handleChange.bind(this);
  }
   componentDidMount(){
    
    document.querySelector('body').classList.remove('login_page');
    document.body.style.backgroundImage = "url('')";
   }

    backButton() {
      window.history.back();
    }

    handleChange(e) {
      changelanguage(e.target.value);
      this.props.changeLanguage(e.target.value);
    }
    UNSAFE_componentWillReceiveProps(nextProps){ 
      if(this.props.currentlanguagelist != nextProps.currentlanguagelist){
        window.location.reload();
      }
    }
    render() {
      let  languagelist = getlanguagelist();
      return (
       
           
            <div className="top_nav inner_header">
                 <div className="container">
            <a className="navbar-brand pull-left" href="/"><img src="https://api.baaldahab.com/backend_assets/website/img/logo.png" /></a>
            
        <ul className="pull-right">
  
            <li><a className="home_icon" href="/"><i className="fas fa-home"></i></a></li>
            <li>
                <select  value={this.state.language} onChange={this.handleChange}>
                    <option value="en"  >English</option>
                    <option value="so"   >Somali</option>
                </select>
            </li>
        </ul>
    </div>
            </div>
        );
    }
  }
  const mapStateToProps = state => {
    return {
            currentlanguage     : state.currentlanguage.currentlanguage.language,
            currentlanguagelist : state.currentlanguage.currentlanguage.languagelist,      
          }
  }
  const mapDispatchToProps = dispatch => {
    return {
       changeLanguage            : bindActionCreators(changeLanguage , dispatch),
  
    }
  }
 export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StaticHeader));
